import { render, staticRenderFns } from "./GalapagosHome.vue?vue&type=template&id=7576b3e1"
import script from "./GalapagosHome.vue?vue&type=script&lang=js"
export * from "./GalapagosHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports